import React from 'react';


function RealEstateInformation({ properties, setProperties, labelPrefix }) {
    const TrashIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="trash-icon" fill="none" viewBox="0 0 24  24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
    </svg>

        );
  const addProperty = () => {
    setProperties([
      ...properties,
      {
        street: "",
        city: "",
        state: "",
        zip: "",
        value: "",
        hasMortgage: "",  // "yes" or "no"
        mortgageCreditor: "",
        mortgageBalance: "",
        mortgageMonthlyPayment: "",
        mortgagePaymentStatus: "", // "yes" if current, "no" if not
        mortgageMonthsBehind: "",
        hasSecondMortgage: "", // "yes" or "no"
        secondMortgageCreditor: "",
        secondMortgageBalance: "",
        secondMortgageMonthlyPayment: "",
        secondMortgagePaymentStatus: "", // "yes" or "no"
        secondMortgageMonthsBehind: ""
      }
    ]);
  };

  const updateProperty = (index, field, value) => {
    const newProperties = [...properties];
    newProperties[index][field] = value;
    setProperties(newProperties);
  };

  const deleteProperty = (index) => {
    const newProperties = properties.filter((_, i) => i !== index);
    setProperties(newProperties);
  };

  return (
    <div className="realestate-section-real">
      <h3>{labelPrefix} Other Real Estate</h3>
      {properties.map((property, idx) => (
        <div className="realestate-form-real">
            <div className="realestate-header">
                <span>{labelPrefix} Property {idx + 1}</span>
                <button className="delete-button" onClick={() => deleteProperty(idx)}>
                <TrashIcon />
                </button>
            </div>
            <div className="realestate-grid-real"><div className="vertical-stack-intake">
  <input
    className="street-input"
    type="text"
    placeholder="Street"
    value={property.street || ""}
    onChange={(e) => updateProperty(idx, "street", e.target.value)}
  />
  <div className="bottom-row">
    <input
      type="text"
      placeholder="City"
      value={property.city || ""}
      onChange={(e) => updateProperty(idx, "city", e.target.value)}
    />
    <input
      type="text"
      placeholder="State"
      value={property.state || ""}
      onChange={(e) => updateProperty(idx, "state", e.target.value)}
    />
    <input
      type="text"
      inputmode="numeric"
      placeholder="Zip"
      value={property.zip || ""}
      onChange={(e) => updateProperty(idx, "zip", e.target.value)}
    /></div>
            </div></div>
              {/* New Value Input */}
  <div className="vertical-stack-intake"><div>$
        <input
        className="value-input"
        inputmode="numeric"
          type="text"
          placeholder="Value"
          value={property.value}
          onChange={(e) => updateProperty(idx, "value", e.target.value)}
        />
        <select name="propertyType" value={property.propertyType} onChange={(e) => updateProperty(idx, "propertyType", e.target.value)}>
                        <option value="">Property Type</option>
                        <option value="single_family">Single-Family Home</option>
                        <option value="duplex">Duplex</option>
                        <option value="condo">Condominium</option>
                        <option value="manufactured">Manufactured Home</option>
                        <option value="land">Land</option>
                        <option value="investment">Investment Property</option>
                        <option value="timeshare">Timeshare</option>
                        <option value="other">Other</option>
        </select>
        </div></div>
            {/* The rest of your property fields */}
            <div>Does it have a mortgage?</div>
          <div className="binary-options-vehicles">
            
            <button className={`binary-button-vehicles ${property.hasMortgage==="yes" ? "selected" : ""}`}
              onClick={() => updateProperty(idx, "hasMortgage", "yes")}>
              Yes
            </button>
            <button className={`binary-button-vehicles ${property.hasMortgage==="no" ? "selected" : ""}`}
              onClick={() => updateProperty(idx, "hasMortgage", "no")}>
              No
            </button>
          </div>
          {property.hasMortgage === "yes" && (
            <><div className="vertical-stack-intake">
              <input
                type="text"
                placeholder="Mortgage Creditor"
                value={property.mortgageCreditor}
                onChange={(e) => updateProperty(idx, "mortgageCreditor", e.target.value)}
              />
              <input
                type="text"
                inputmode="numeric"
                placeholder="Mortgage Balance"
                value={property.mortgageBalance}
                onChange={(e) => updateProperty(idx, "mortgageBalance", e.target.value)}
              />
              <input
                type="text"
                inputmode="numeric"
                placeholder="Monthly Payment"
                value={property.mortgageMonthlyPayment}
                onChange={(e) => updateProperty(idx, "mortgageMonthlyPayment", e.target.value)}
              /></div>
              <div>Is it current?</div>
              <div className="binary-options-vehicles">
                
                <button className={`binary-button-vehicles ${property.mortgagePaymentStatus==="yes" ? "selected" : ""}`}
                  onClick={() => updateProperty(idx, "mortgagePaymentStatus", "yes")}>
                  Yes
                </button>
                <button className={`binary-button-vehicles ${property.mortgagePaymentStatus==="no" ? "selected" : ""}`}
                  onClick={() => updateProperty(idx, "mortgagePaymentStatus", "no")}>
                  No
                </button>
              </div>
              {property.mortgagePaymentStatus === "no" && (<div className="vertical-stack-intake">
                <input
                  type="text"
                  inputmode="numeric"
                  placeholder="Months Behind"
                  value={property.mortgageMonthsBehind}
                  onChange={(e) => updateProperty(idx, "mortgageMonthsBehind", e.target.value)}
                /></div>
              )}
              {/* Second Mortgage */}
              <div>Does it have a 2nd mortgage?</div>
              <div className="binary-options-vehicles">
                
                <button className={`binary-button-vehicles ${property.hasSecondMortgage==="yes" ? "selected" : ""}`}
                  onClick={() => updateProperty(idx, "hasSecondMortgage", "yes")}>
                  Yes
                </button>
                <button className={`binary-button-vehicles ${property.hasSecondMortgage==="no" ? "selected" : ""}`}
                  onClick={() => updateProperty(idx, "hasSecondMortgage", "no")}>
                  No
                </button>
              </div>
              {property.hasSecondMortgage === "yes" && (
                <><div className="vertical-stack-intake">
                  <input
                    type="text"
                    placeholder="Second Mortgage Creditor"
                    value={property.secondMortgageCreditor}
                    onChange={(e) => updateProperty(idx, "secondMortgageCreditor", e.target.value)}
                  />
                  <input
                    type="text"
                    inputmode="numeric"
                    placeholder="Second Mortgage Balance"
                    value={property.secondMortgageBalance}
                    onChange={(e) => updateProperty(idx, "secondMortgageBalance", e.target.value)}
                  />
                  <input
                    type="text"
                    inputmode="numeric"
                    placeholder="Second Mortgage Monthly Payment"
                    value={property.secondMortgageMonthlyPayment}
                    onChange={(e) => updateProperty(idx, "secondMortgageMonthlyPayment", e.target.value)}
                  /></div>
                  <div >Are you current on your second mortgage?</div>
                  <div className="binary-options-vehicles">
                    <button className={`binary-button-vehicles ${property.secondMortgagePaymentStatus==="yes" ? "selected" : ""}`}
                      onClick={() => updateProperty(idx, "secondMortgagePaymentStatus", "yes")}>
                      Yes
                    </button>
                    <button className={`binary-button-vehicles ${property.secondMortgagePaymentStatus==="no" ? "selected" : ""}`}
                      onClick={() => updateProperty(idx, "secondMortgagePaymentStatus", "no")}>
                      No
                    </button>
                  </div>
                  {property.secondMortgagePaymentStatus === "no" && (<div className="vertical-stack-intake">
                    <input
                      type="text"
                      inputmode="numeric"
                      placeholder="Months Behind"
                      value={property.secondMortgageMonthsBehind}
                      onChange={(e) => updateProperty(idx, "secondMortgageMonthsBehind", e.target.value)}
                    /></div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      ))}
      <button className="action-button" onClick={addProperty}>Add another property</button>
    </div>
  );
}

export default RealEstateInformation;